import styled from 'styled-components'
import { minmedia } from '../../styles/media-queries'

import { bordergray, lightgray, almostblack, white, darkgray, red } from '../../styles/colors'

export const UploadContainer = styled.div`
  width: calc(50% - 0.5rem);
  border: 2px dashed ${bordergray};
  position: relative;
  cursor: pointer;
  user-select: none;
  margin-bottom: 1rem;
  &::before {
    content: '';
    display: block;
    padding-top: 100%;
  }
  input {
    opacity: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    cursor: pointer;
    left: 0;
    top: 0;
  }
`

export const Label = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  color: ${darkgray};
`

export const ContentContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  svg {
    margin-bottom: 0.5rem;
    cursor: pointer;
    width: 2.5rem;
    height: 2.5rem;
    ${minmedia.large`
    width: 4rem;
    height: 4rem;
    `};
  }
  p {
    width: 100%;
    margin-bottom: 0;
    text-align: center;
    font-size: 18px;
    ${minmedia.large`
    font-size: 18px;
    `};

    color: ${lightgray};
  }
`

export const Feedback = styled.div`
  width: 100%;
  display: ${props => (props.valid ? 'none' : 'block')};
  color: ${red};
  margin-top: -1.5rem;
`

export const Image = styled.div`
  width: calc(50% - 0.5rem);
  position: relative;
  margin-bottom: 1rem;
  border: 3px dashed ${bordergray};
  &::before {
    content: '';
    display: block;
    padding-top: 100%;
  }
`

export const Background = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background-position: center center;
  background-size: cover;
`

export const FlexContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
`

export const Overlay = styled.div`
  transition: opacity 0.5s;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: ${almostblack};
  opacity: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  svg {
    fill: ${white};
    width: 3rem;
    height: 3rem;
  }
  &:hover {
    opacity: 0.8;
  }
`



// WEBPACK FOOTER //
// ./src/components/Upload/styles.js